import React, { useEffect } from 'react';
import './fileBrowserLaunchFx.css';

/** Black-box overlay. `onDone` = animation finished (window already opened). */
export default function FileBrowserLaunchFx(props: { play: boolean; onDone: () => void }) {
  useEffect(() => {
    if (!props.play) {
      return;
    }
    const id = window.setTimeout(() => props.onDone(), 880);
    return () => window.clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.play]);

  if (!props.play) {
    return null;
  }

  return (
    <div className="fblfx" aria-hidden>
      <div className="fblfx-warp" />
      <div className="fblfx-bloom" />
      <div className="fblfx-ring" />
      <div className="fblfx-ring fblfx-ring2" />
      <div className="fblfx-core" />
    </div>
  );
}
